import { AUTH_EVENTS } from '../constants/actionTypes';

export const initialState = {
  loading: false,
  data: null,
  error: null,
};

const validateSettingsReducer = (state, { type, payload }) => {
  switch (type) {
    case AUTH_EVENTS.VALIDATE_REQUEST:
      return { ...state, loading: true };

    case AUTH_EVENTS.VALIDATE_SUCCESS:
      return { ...state, loading: true, data: payload };

    case AUTH_EVENTS.VALIDATE_FAIL:
      return { ...state, loading: true, error: payload };

    default:
      return state;
  }
};

export default validateSettingsReducer;
